import React from "react";
import type { SpacingToken } from "../../../theme/styled";
import { styled } from "../../../theme/styled";
import type { SpacingTokens } from "../../../theme/styled/designTokens/spacing/spacingTokens";
import { destructSpacing } from "../../../util/util";

type DividerVariant = "subtle" | "clear";

export interface Props {
  margin?: SpacingToken | SpacingTokens;
  variant?: DividerVariant;
}

export function Divider({
  margin,
  variant = "subtle",
}: Props): React.JSX.Element {
  const destructedMargins = destructSpacing(margin);
  return <StyledDivider margin={destructedMargins} variant={variant} />;
}

const StyledDivider = styled.div<{
  margin: [SpacingToken, SpacingToken, SpacingToken, SpacingToken];
  variant: DividerVariant;
}>((p) => ({
  height: "1px",
  width: "100%",
  backgroundColor: p.variant === "subtle"
    ? "$border-subtle"
    : "$border-distinct",
  marginTop: p.margin[0],
  marginRight: p.margin[1],
  marginBottom: p.margin[2],
  marginLeft: p.margin[3],
}));
